import _ from '@lodash';
import { useState, useEffect, useRef } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useRouter from '@fuse/hooks/useRouter';
import useToast from '@fuse/hooks/useToast';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';
import axios from "@fuse/utils/axios";
import { openFormViewerDialog,setFromData } from '../store/formViewDialogReducer';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import 'styles/ag-grid-header-style.css';
import GeneralModal from '@fuse/components/Modal/GeneralModal';
import { setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import ActivityAgGridListingSameAsSam from '@fuse/components/ActivitieLogs/activitiesAgGridListingSameAsSam';

const useStyles = makeStyles({
	layoutRoot: {},
	head: {
		position: "sticky",
		top: 0
	},
	root: {
		// minWidth: 275,
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
});

function ListView(props) {
  const classes = useStyles();
	const gridRef = useRef();
	const table_name = "SLA";
	const router = useRouter();
	const dispatch = useDispatch();
	const toast = useToast(dispatch);
	// const rowGroupPanelShow = 'always';
	const skipHeader = ['id']
	const [windowHeight, setWindowHeight ]  = useState(window.innerHeight - 330);
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const [slaDetails, setSlaDetails] = useState({})
	const [logs,setLogs] = useState([]);
	const [groupByArr, setGroupByArr] = useState([])
	const [tabValue, setTabValue] = useState(0)
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [filterApplied, setFilterApplied] = useState(false);
	const query_data = useSelector((state) => state.reportApp.reportViewDialogReducer.quick_filter);
	const frameworkComponents = {
		customFilter: CustomFilter,
	};
	const handleClickOpen = () => {
		setOpenDeleteDialog(true);
	};
	const [loadingActivityLog,setLoadingActivityLog] = useState(false);

  function setHeaderName(header){
		return header.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
  }
  const tab_value = useSelector(
	(state) => state.reportApp.reportViewDialogReducer.tab_value
	);

	useEffect(()=>{
		setTabValue(tab_value)
	}, [tab_value])

  	useEffect(()=>{
			gridRef.current.api?.setQuickFilter(query_data);
	},[query_data])
	
	useEffect(()=>{
		return () => {
			dispatch(setQuickFilter(null))
		}
	},[props.endUsersAccounts])

	const handleClose = () => {
		setOpenDeleteDialog(false);
	};

	const handleDeleteDialogOpen = (data) => {
		handleClickOpen()
		setSlaDetails(data)
	}

	const onGridReady = (params) => {
		gridRef.current = params;
		if(router.query.report_name == undefined) {
			loadInitialState (params);
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]))
		}else{
			getReport(params);
		}
	}

	const onGridSizeChanged = ()=>{
		// setWindowHeight(window.innerHeight - 290);
	}
	
	function onFilterChanged(event){
		const rows = event.api.getFilterModel();
		// to show No result found in column filter
		dispatch(setfilterlist(rows));
		saveView("N/A", rows,gridRef.current.filterModelArr)
		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if(total_rows === 0 ){
			event.api.showNoRowsOverlay();
		}else{
			event.api.hideOverlay();
		}
	}

	function onCellValueChanged(e){

		const payload = {
			sla: e.data.service_level_agreement_name,
			id:e.data.id,
		}
		if(!payload.sla){
			toast.error('Service Level Agreement is required')
			props.refresh()
			return
		}
		axios.put('/service-level-agreement/update', payload).then(response => {
			if(response.status == 201){
				toast.error(response.data.message)
				props.refresh()
			} else {
			//   onSuccess()
			  toast.success('Service Level Agreement updated successfully.')
			  props.refresh()
			//   props.fetchAllHardwareAssets()
			}
		}).catch(err => {
		  console.log('212=>',err);
		  toast.error('Something went wrong!')
		})

	}

	function getReport(event){
		const {report_name} = router.query;
		const table_name = "service level agreement";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
		.then(results=>{
			const model = JSON.parse(results.data.data.filter);
			event.api.setFilterModel(model);
			const row_model = JSON.parse(results.data.data.row_model);
			event.api?.getColumnState(row_model);
		})
		.catch(err=>{
			console.log(err);
		})
	}

	function loadInitialState(params) {
    axios
      .get(`/user-view/show-view-order?table_name=${table_name}`)
      .then((results) => {
        const { data } = results.data;
		if (data !== null) {
			const order = JSON.parse(data.order);
			const filter = JSON.parse(data.filter);
			gridRef.current = {...gridRef.current,filterModelArr:filter}

			params?.api?.applyColumnState({ state: order });
			params?.api.setFilterModel(filter);
			if (filter && Object.keys(filter)?.length) {
				setFilterApplied(true)
			}
		}
      })
      .catch((err) => {
        console.log(err);
      });
  }

	function saveView(rows, filter) {
		let payload = {}
		if(rows == 'N/A'){
		payload = {
			filter:  JSON.stringify(filter),
			table_name
		}
		}else{
		payload = {
			order:  JSON.stringify(rows),
			table_name
		}
		}
		axios.post('/user-view/save-view-order',payload)
		.then(()=>{
		console.log('view updated')
		})
		.catch(err=>{
		console.log(err);
		})
	}

	const onColumnMoved = (params) => {
		const rows = params.api?.getColumnState();
		saveView(rows);
		dispatch(setrowGroupModel(rows))
	}

	function onColumnVisible(params){
		const rows = params.api?.getColumnState();
		dispatch(setrowGroupModel(rows))
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row=>{
			const { hide } = row;
			if(hide) {
				++total_hidden_columns;
			}
		});
		if( total_hidden_columns < total_no_of_columns){
			saveView(params.api.getColumnState());
		}
	}
	function onSortChanged(params){
    if (router.query.report_name == undefined) {
      const rows = params.api?.getColumnState();
			dispatch(setrowGroupModel(rows));
      saveView(rows);
    }
  }

	function onColumnRowGroupChanged(event){
		if(event.columns.length == 0) {
			setGroupByArr([])
		}else{
			setGroupByArr(event.columns)
		}
		if (router.query.report_name == undefined) {
			const rows = event.api?.getColumnState();
			const first_row = rows[1];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
			  dispatch(setrowGroupModel(rows));
			  saveView(rows);
			} else {
			  dispatch(setrowGroupModel(rows));
			}
		  }
	}
	
	function handelEdit(data){
		dispatch(setFromData(data))
		// props.refresh()
		dispatch(openFormViewerDialog())
	}

	const onColumnPinned = (params) =>{
		if(router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			saveView (rows);
			dispatch(setrowGroupModel(rows))
		}
	}

	function handleDelete(){
		axios.delete(`/service-level-agreement/delete/${slaDetails?.id}`).then((res)=>{
			if(res.status === 201){
				toast.error(res.data.message)
			}else{
				toast.success(res.data.message)
				handleClose()
				props.refresh()
			}
		}).catch((err)=>{
			console.log('err',err.response);
			toast.error(err.response.data.message);
		})
	}

	function formatLogs(data){
		return data.map((item)=>{
			return {
				id:item.id,
				action_id: `act${item.id}`,
				action_date_and_time: item.created_at,
				service_level_agreement_name: item?.service_level_agreement?.sla_name || item.sla_name,
				name: item.user_name,
				action: item.action_name,
				description: item.comment,
				previous_value: item.previous_data,
				current_value: item.current_data,
				field_name: item.action_field_name,
				user_role: item.user_role_name,
				company_name: item?.user_company?.company_name,
			}
		})
	}

	function getLogs(){
		setLoadingActivityLog(true)

		axios.get('/service-level-agreement/activities')
		.then(({data})=>{
			setLogs(formatLogs(data.data.activities));
			setLoadingActivityLog(false)

		})
		.catch(err=>{
			console.log('cannot fetch logs');
		})
	}

	const handleChildClick = (value) => {
		setTabValue(value)
  	};

		useEffect(()=>{
			if(tabValue == 1){
				getLogs()
				setFilterApplied(false)
			}
		},[tabValue])

	return (			
		<>
		{ (tabValue == 0) &&
			<AgGridFilterGroupView
				tableRef={gridRef} 
				setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList ={ groupByArr }
				tableName="service_level_agreement"
				logs={logs}
				displayTableName = "Service Level Agreements"
				onClick={handleChildClick}
			/>}
			{(tabValue == 1) && (<ActivityAgGridListingSameAsSam module="service_level_agreement" logs={logs} displayTableName = "Service Level Agreements"
				addPermission = {props.createSLAggrementPermission}
				loadingActivityLog={loadingActivityLog}
				/>)}
			{(tabValue == 0) &&
				<div className="ag-theme-alpine" style={{width: "100%",height:windowHeight+105,fontSize:'12px'}}>
					<AgGridReact
						ref={gridRef}
						theme='legacy'
						rowData={props.endUsersAccounts}
						onGridReady = { onGridReady }
						animateRows
						rowHeight={30}
						headerHeight={44}
						onGridSizeChanged = { onGridSizeChanged }
						// Set the desired sheet name
						defaultExcelExportParams={{
							sheetName: 'Dalos-Source'
						}}
						defaultColDef={{
							enableRowGroup:true,
							resizable: true
						}}
						// no rows overlay 
						overlayNoRowsTemplate="<span>No Result Found</span>"
						
						// get filter model
						onFilterChanged = { onFilterChanged }		
						onColumnMoved = { onColumnMoved }	
						onColumnVisible = { onColumnVisible }
						onColumnPinned = { onColumnPinned }
						onSortChanged={onSortChanged}

						// row grouping
						showOpenedGroup
						suppressDragLeaveHidesColumns
						suppressMakeColumnVisibleAfterUnGroup
						rowGroupPanelShow={ rowGroupPanelShow }
						onColumnRowGroupChanged = { onColumnRowGroupChanged }
						groupHeaderHeight ={1}
						// headerHeight = {15}
						floatingFiltersHeight = {40}
						components={frameworkComponents}
						pagination
						columnDefs={[
							...Object.keys(props.endUsersAccounts[0])
								.filter((header) => !skipHeader.includes(header))
								.map((header) => {
									return {
										field: header,
										sortable: true,
										key: header,
										minWidth: 200,
										filter: 'agTextColumnFilter',
										flex: 1,
										onCellValueChanged,
										headerName: setHeaderName(header),
										headerComponent: (props) => (CustomFilter(props, header, gridRef)),
									};
								})
						]}
					>
						{/* <AgGridColumn
							lockPosition={true}
							rowSelection={'single'}
							width={100}
							minWidth={100}
							maxWidth={100}
							suppressSizeToFit={true}
							headerName="Actions"
							pinned= 'right' 
							lockPinned={true}
							className="action_field"
							cellRenderer={({data}) =>{
								if(data){
									return (
										<>
											{ props.updateSLAggrementPermission && <Tooltip id="edit" title="Edit" placement="top"
										><Icon onClick={() => handelEdit(data) }
										style={{
											color: '#1d2939',
											paddingBottom: '5px',
											paddingRight:'30px',
											fontSize:'15px',
											cursor:'pointer'
										}}
										>edit</Icon></Tooltip>}
										{props.deleteSLAggrementPermission && <Tooltip id="delete" title="Delete" placement="top" ><Icon
										onClick={() => handleDeleteDialogOpen(data) }
										style={{
											color: '#1d2939',
											paddingBottom: '3px',
											paddingRight:'30px',
											fontSize:'15px',
											cursor:'pointer'
										}}>delete</Icon></Tooltip>}
						
										</>
									)
								}else{
									return (<></>)
								}
							}}
						>
						</AgGridColumn> */}
					</AgGridReact>
				</div>
			}
			<GeneralModal
				open={openDeleteDialog}
				title="Delete Service Level Agreement"
				text={<h4>Are you sure to delete this Service Level Agreement named as <b>{slaDetails?.service_level_agreement_name}</b>?</h4>}
				handleClose={handleClose}
				handleConfirm={handleDelete}
			/>
		</>
	);
}

export default ListView

